import React, { Component } from 'react';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import ModalConfirmacao from './ModalConfirmacao';

const isSimulacao = localStorage.getItem("isSimulacao") === 'true';
const isPro = localStorage.getItem("isPro") === 'true';

class RemoverResultadoItem extends React.Component {

	constructor(props) {
		super(props);
		this.confirmacao = React.createRef();
		
		this.state = {
			icoOver: false
		}
	}

	removerResultado = () => {		
		return new Promise((resolve, reject) => {
			HttpUtil.eco_POST(Config.urls.API_URL_BASE + 'HistoricoArquivos/RemoverConsultaResultado', JSON.stringify(this.props), (response) => {
				resolve();
			}, () => { console.log('Ocorreu um erro ao executar a requisição'); })
		});
	}

	prepararParaRemoverRegistro = () => {
		this.removerResultado().then(() => {
			this.props.action();
		});
	}

	confirmarRemocaoRegistro = () => {
		this.confirmacao.current.alterarVisibilidadeModal();
	}

	mouseOverHandler = () => {
		this.setState({ icoOver: !this.state.icoOver });
	}

	mouseLeaveHandler = () => {
		this.setState({ icoOver: false });
	}

	render() {
		if (isSimulacao || isPro)
			return null;

		return (
			<div className="d-inline">
				<i className={this.state.icoOver ? 'ecoico ecoico-excluir-red' : 'ecoico ecoico-excluir-cinza'} onMouseEnter={this.mouseOverHandler} onMouseLeave={this.mouseLeaveHandler} onClick={() => this.confirmarRemocaoRegistro()}></i>
				<ModalConfirmacao ref={this.confirmacao} mensagemAlerta="Deseja realmente apagar esse arquivo?" action={this.prepararParaRemoverRegistro.bind(this)} />
			</div>
		);
	}
}

export default RemoverResultadoItem;


// WEBPACK FOOTER //
// ./src/Componente/Modulo/RemoverResultadoItem.jsx